import { Model } from '@/clients/http'

import type {
  ReviewApiError,
  ReviewByIdParams,
  ReviewItemResponse,
  ReviewListParams,
  ReviewListResponse,
  ReviewStatusParams,
} from '@/types/reviews'

export class ReviewModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_REVIEW_LIST',
    UPDATE_STATUS: 'UPDATE_REVIEW_STATUS',
    DELETE: 'DELETE_REVIEW',
  }

  public static readonly endpoints = {
    list: (props?: ReviewListParams) =>
      this.createEndpoint({ url: '/api/backoffice/review', query: props?.query }),
    status: (props: ReviewByIdParams) =>
      this.createEndpoint({ url: '/api/backoffice/review/:id/status', params: props.params }),
    byId: (props: ReviewByIdParams) =>
      this.createEndpoint({ url: '/api/backoffice/review/:id', params: props.params }),
  }

  public static readonly getList = async (props?: ReviewListParams) =>
    this.createHttpRequest<ReviewListResponse, ReviewApiError>({
      correlationKey: this.correlations.GET_LIST,
      payload: { method: 'get', url: this.endpoints.list(props), useBearerToken: true },
    })

  public static readonly updateStatus = async (props: ReviewStatusParams) =>
    this.createHttpRequest<ReviewItemResponse, ReviewApiError>({
      correlationKey: this.correlations.UPDATE_STATUS,
      payload: { method: 'put', url: this.endpoints.status(props), body: props.body, useBearerToken: true },
    })

  public static readonly delete = async (props: ReviewByIdParams) =>
    this.createHttpRequest<{ message: string }, ReviewApiError>({
      correlationKey: this.correlations.DELETE,
      payload: { method: 'delete', url: this.endpoints.byId(props), useBearerToken: true },
    })
}
